import React from 'react';
import { Card, Typography, Space, Tag, Divider, Row, Col } from 'antd';
import { CloudUploadOutlined, CloudDownloadOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const BackupRestore: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <CloudUploadOutlined style={{ marginRight: 8 }} />
              Backup & Restore
            </Title>
            <Tag color="orange">Upcoming Feature</Tag>
          </div>
          
          <Divider />
          
          <div>
            <Title level={4}>Data Management</Title>
            <Paragraph>
              This page will provide comprehensive backup and restore functionality.
              Features will include:
            </Paragraph>
            
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Card size="small" title={<><CloudUploadOutlined /> Backup</>}>
                  <ul>
                    <li>Automated backup scheduling</li>
                    <li>Manual backup creation</li>
                    <li>Cloud storage integration</li>
                    <li>Backup verification</li>
                  </ul>
                </Card>
              </Col>
              <Col span={12}>
                <Card size="small" title={<><CloudDownloadOutlined /> Restore</>}>
                  <ul>
                    <li>Point-in-time recovery</li>
                    <li>Selective data restoration</li>
                    <li>Restore verification</li>
                    <li>Rollback capabilities</li>
                  </ul>
                </Card>
              </Col>
            </Row>
          </div>
          
          <div style={{ 
            background: '#fff7e6', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #ffd591'
          }}>
            <Space>
              <InfoCircleOutlined style={{ color: '#fa8c16' }} />
              <Text type="secondary">
                Data protection and recovery features are being developed to ensure your data safety.
              </Text>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default BackupRestore;
